<template>
  <v-container grid-list-xl fluid>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md12>
        <h1>로그인</h1>
        <h1>Login</h1>
      </v-flex>

      <v-flex xs12 md12>
        <v-form ref="form">
          <v-layout row wrap>
            <v-flex pa-0 xs12>
              <v-subheader class="formlabel"
                >휴대전화 Mobile Phone Number</v-subheader
              >
            </v-flex>
            <v-flex py-0 xs3 formlabeless>
              <v-select
                :items="countries"
                label=""
                prefix=""
                v-model="cc"
                xs6
              ></v-select>
            </v-flex>
            <v-flex py-0 xs9 formlabeless>
              <v-text-field
                v-model="phone"
                :rules="[rules.phone]"
                :error-messages="phone_error_messages"
                :disabled="phone_validated"
                @input="phone_error_messages = []"
                label=""
                type="number"
                pattern="\d*"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="password"
                :error-messages="password_error_messages"
                @input="password_error_messages = []"
                type="password"
                label="Password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <v-flex xs12 md12 text-xs-right>
        <v-btn @click="login">로그인 / Login</v-btn>
      </v-flex>
      <br />
      꿀팁: 휴대폰 가입 인증 시 기본 패스워드를
      <br />
      생성하여 휴대폰으로 보냈습니다
      <br />
      Remember: Your first password has already been sent to your phone
      <br />
      <br />
      <br />
      <v-btn flat to="/forgot_password">패스워드 찾기 / Forgot Password</v-btn>
      <br />
      <br />
      <br />
      <v-btn flat @click="forgetme">Stop Remembering My Phone Number</v-btn>
      <v-btn flat @click="forgetme">내 전화번호 자동 넣지 마세요</v-btn>
    </v-layout>
    <br />
    <h2 class="headline font-weight-bold mb-3">Need Help?</h2>
    Having trouble or need help? Email 주소 daltotheworld@gmail.com
  </v-container>
</template>

<script>
import {country_abbreviation_to_country_code, phone_countries} from '@/settings';
export default {
  props: ['auth'],
  data: () => ({
    cc: '',
    phone: '10',
    phone_validated: false,
    phone_error_messages: [],
    password: '',
    password_error_messages: [],
    valid: false,
    countries: phone_countries,
    rules: {
      phone: value => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Invalid phone number';
      },
    },
  }),
  mounted: async function () {
    let oldcc = localStorage.getItem('last_cc');
    let oldphone = localStorage.getItem('last_phone');

    if (oldcc) {
      this.cc = oldcc;
    }
    if (oldphone) {
      this.phone = oldphone;
    }
    if (!oldcc && !oldphone) {
      var res = await this.auth.guess_country();
      console.log("country_abbreviation_to_country_code", country_abbreviation_to_country_code)
      this.$data.cc = country_abbreviation_to_country_code[res.data.country];
    }
  },
  watch: {
    phone(to) {
      if (to?.startsWith('0')) {
        this.$data.phone = to.replace(/^0/, '');
      }
    },
    cc(to, from) {
      if (to != '+82' && this.$data.phone == '10') {
        this.$data.phone = '';
      }
      if (to == '+82' && !this.$data.phone) {
        this.$data.phone = '10';
      }
    },
  },
  methods: {
    forgetme() {
      localStorage.removeItem('last_cc');
      localStorage.removeItem('last_phone');
      this.cc = '+82';
      this.phone = '10';
    },
    login: async function({router}) {
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        let nicephone = this.$data.cc + this.$data.phone;
        var res = await this.auth.login(nicephone, this.password);
        console.log('login result', res);
        if (!res.data.success) {
          this.password_error_messages = res.data.message;
        } else {
          localStorage.setItem('last_cc', this.$data.cc);
          localStorage.setItem('last_phone', this.$data.phone);

          this.valid = true;
          this.$router.push('/');
        }
      } catch {
        this.password_error_messages = 'Network Error';
      }
    },
  },
};
</script>
<style scoped>
.formlabel {
  height: auto;
  padding: 0 10px;
}
.formlabeless .v-input {
  padding-top: 0px;
}
</style>
